import { createContext, useReducer, useEffect } from "react";

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload };
    case "LOGOUT":
      return { user: null };
    case "UPDATE_USER":
      const updatedState = {
        ...state,
        user: { ...state.user, ...action.payload },
      };
      console.log("Updated State:", updatedState);
      return updatedState;
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user) {
      dispatch({ type: "LOGIN", payload: user });
    }
  }, []);

  // New useEffect hook to update localStorage when state.user changes
  useEffect(() => {
    if (state.user) {
      const storedUser = JSON.parse(localStorage.getItem("user")) || {};
      // Update only specific fields (e.g., assessments) or replace the entire object
      const updatedUser = { ...storedUser, ...state.user };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    }
  }, [state.user]);

  console.log("AuthContext state: ", state);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
